import { Design } from 'blaze-ui/icons'

interface Props {
  emoji: string | null
}

export const DesignEmoji = ({ emoji }: Props) => {
  if (emoji) return <span>{emoji}</span>

  return <Design />
}
